import React from 'react';
import { FormControl, FormControlLabel, FormHelperText, Switch, SwitchProps } from '@material-ui/core';

export type SGSSwitchProps = SwitchProps & {
    error?: boolean;
    label?: string;
    helperText?: string;
    className?: string;
};

const SGSSwitch: React.FC<SGSSwitchProps> = ({ label, error, helperText, className = 'mb-0', ...props }) => (
    <FormControl error={error}>
        <FormControlLabel control={<Switch color="primary" {...props} />} label={label} className={className} />
        {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
);

export default SGSSwitch;
